import { render, staticRenderFns } from "./TextareaFieldStudent.vue?vue&type=template&id=23405c93&"
import script from "./TextareaFieldStudent.vue?vue&type=script&lang=js&"
export * from "./TextareaFieldStudent.vue?vue&type=script&lang=js&"
import style0 from "./TextareaFieldStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
